<template>
<div>
  <Alert  text="PLANO GRATUITO"
      callbackText="ASSINAR"
      :callback="() => $router.push({ path: '/assinatura/planos' })"
      :plan="true"       :backButton="true"
/>
       <div class="row " style="height: 56vh">
     <div class="col-md-6 h-100 img-login" :style="`background-image: url('https://bucketrecreativa.s3.amazonaws.com/coruja.png')`">
    </div>
    <div class="col-md-6 d-flex flex-column justify-content-center align-items-center">
      <div class="card" style="width: 65%">
        <Input title="Novo password" type="password" v-model="new_password" />
        <Input title="Confirmar password" type="password" v-model="confirm_new_password" />
        <button @click="changePassword" class="btn-login">Redefinir senha</button>
      </div>
    </div>
  </div>
  <Alert text="VEJA AS NOVIDADES!" />
    <SliderBottom />
</div>
 
</template>

<script>
import Input from '../components/Input'
import Alert from '../components/AlertaPlano'
import SliderBottom from '../components/SliderBottom'
export default {
  name: "Recovery",
  components:{
    Input,
    Alert,
    SliderBottom
  },
  data: () => ({
    new_password: '',
    confirm_new_password: ''
  }),
  created: function(){
    this.analyticSubmit();
  },
  methods: {
    changePassword: function () {
      this.$store.commit('loading', true)
      if (this.new_password === this.confirm_new_password) {
          this.$axios
            .post(`redefinir_senha`, {token: this.$route.params.token, password: this.new_password})
            .then((res) => res.data)
            .then((res) => {
                  this.$store.commit('loading', false)
                  localStorage.setItem('t', JSON.stringify(res.token))
                  this.$store.commit("logado", true)
                  this.$store.commit("setStateModal", {
                  visible: true,
                  title: "Sucesso",
                  type: "success",
                  message: "Senha redefinida com sucesso! Faça login para começar a jogar.",
                });
                this.$router.push({path: '/'})
            })
            .catch((e) => {
              this.$store.commit('loading', false)
              this.$store.commit("setStateModal", {
                visible: true,
                title: "ATENÇÃO",
                type: "warning",
                message: e.response.data.message,
              });
            });
        } else {
          this.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "warning",
            message: "Verifique se as senhas coincidem.",
          });
        }
    },
    analyticSubmit: function(){
      try {
        this.$intercom.trackEvent("WEB_tela_redefinirSenha");
      } catch (error) {
        console.log("analyticIntercom redefinir senha error:", error)
      }
    }
  },
};
</script>

<style scoped>
.card{
    border: none;
    padding: 30px 40px;
    box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.200);
    border-radius: 0;
    font-size: 14px !important;
    position: relative;
}

.btn-login{
  width: 100%;
  height: 50px;
  bottom: -50px;
  left: 0;
  border: none;
  font-size: 18px;
  background-color: #8d4d9a;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
  position: absolute;
  text-transform: uppercase;
  transition: ease .5s;
}

.btn-login:hover{
  transform: scale(1.05);
}

.label{
  font-size: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
}
</style>